import React from 'react';
import Section2a from './Section2a';
import Section2b from './Section2b';
function Section2() {
    return (
        <div id="section-2" className="section-2">
            <Section2a />
            <Section2b />
        </div>
    )
}

export default Section2
